export default __webpack_public_path__ + "images/324bfbfdcee53378914c9edee7862525-7_4K_1920x544.jpg";